import type { WriteRejection } from "@estelle/domain";

/**
 * Turn one `WriteRejection` into a sentence someone can act on.
 *
 * Copied from `modules/contacts/screens/ContactTypes.tsx` rather than
 * imported from it — that file exports a component and nothing else, by the
 * same rule this module follows, so a shared helper has nowhere to live but
 * duplicated at the point of use until there is a common home for it.
 *
 * A switch with no `default` means a sixth `WriteRejection` kind added to
 * `@estelle/domain` fails this file at compile time instead of silently
 * falling through to a generic "something went wrong."
 */
export function describeRejection(rejection: WriteRejection): string {
  switch (rejection.kind) {
    case "blocked":
    case "channel_rejected":
      return rejection.message;
    case "conflict":
      return `${rejection.message} (it changed at ${rejection.currentUpdatedAt})`;
    case "forbidden":
      return `${rejection.message} (requires ${rejection.permission})`;
    case "invalid":
      return rejection.fields
        ? `${rejection.message} ${Object.entries(rejection.fields)
            .map(([field, problem]) => `${field}: ${problem}`)
            .join("; ")}`
        : rejection.message;
  }
}
